import { render, staticRenderFns } from "./FunctionContent.vue?vue&type=template&id=b74485e6&scoped=true"
import script from "./FunctionContent.vue?vue&type=script&lang=js"
export * from "./FunctionContent.vue?vue&type=script&lang=js"
import style0 from "./FunctionContent.vue?vue&type=style&index=0&id=b74485e6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b74485e6",
  null
  
)

export default component.exports